<div class="step-container registration-partner-invite">
  <div class="d-flex flex-column justify-content-between">
    <h5 class="registration-partner-title text-primary">
      {{ 'fgbcl.registration.partner.invite.title' | translate : { fgbdefault: 'Partner Invitation Details' } }}
    </h5>
    <p
      class="registration-partner-invite-instruction mb-0"
      [innerHtml]="'fgbcl.registration.partner.invite.instruction' | translate | markdownTranslate"
    ></p>

    <form class="partner-invite-form d-flex flex-lg-row flex-column" [formGroup]="partnerForm">
      <div class="form-input d-flex flex-column">
        <div class="form-floating w-100">
          <input
            type="text"
            class="partner-code form-control"
            formControlName="PartnerCode"
            placeholder="{{ 'registration.partner.code.placeholder' | translate : { fgbdefault: 'Enter partner code' } }}"
            name="PartnerCode"
          />
          <label class="mb-2 partner-code-label">
            {{ 'registration.partner.code' | translate : { fgbdefault: 'Partner Code' } }}
          </label>
        </div>
        <div
          class="error-message"
          *ngIf="partnerForm?.get('PartnerCode')?.hasError('empty') && partnerForm?.get('PartnerCode')?.touched"
        >
          {{
            'fgbcl.registration.partner.invite.partner.code.empty'
              | translate : { fgbdefault: 'Please enter the partner code received' }
          }}
        </div>
        <div
          class="error-message"
          *ngIf="partnerForm?.get('PartnerCode')?.hasError('required') && partnerForm?.get('PartnerCode')?.touched"
        >
          {{ 'fgbcl.registration.partner.invite.partner.code.required' | translate : { fgbdefault: 'Partner code is required' } }}
        </div>
      </div>

      <div class="form-input d-flex flex-column">
        <div class="form-floating w-100">
          <input
            type="text"
            class="secret-code form-control"
            placeholder="{{ 'registration.partner.secret.code.placeholder' | translate : { fgbdefault: 'Enter secret code' } }}"
            name="PartnerSecretCode"
            formControlName="PartnerSecretCode"
          />
          <label class="mb-2 secret-code-label">
            {{ 'registration.partner.secret.code' | translate : { fgbdefault: 'Partner Secret Code' } }}
          </label>
        </div>
        <div
          class="error-message"
          *ngIf="partnerForm?.get('PartnerSecretCode')?.hasError('empty') && partnerForm?.get('PartnerSecretCode')?.touched"
        >
          {{
            'fgbcl.registration.partner.invite.partner.secret.code.empty'
              | translate : { fgbdefault: 'Please enter the partner secret code received' }
          }}
        </div>
        <div
          class="error-message"
          *ngIf="partnerForm?.get('PartnerSecretCode')?.hasError('required') && partnerForm?.get('PartnerSecretCode')?.touched"
        >
          {{
            'fgbcl.registration.partner.invite.partner.secret.code.required'
              | translate : { fgbdefault: 'Partner secret code is required' }
          }}
        </div>
      </div>
    </form>

    <!-- Server side error -->
    <fgbcl-errors></fgbcl-errors>
  </div>

  <div class="registration-navigataion-button-container">
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
</div>
